<template>
  <div class="popup__layer active">
    <div class="popup__edit" :class="{ big: fieldToEdit === 'picture' }">
      <div class="popup__edit--title">
        {{ $t(`profile.edit.${fieldToEdit}`) }}
      </div>
      <div class="popup__close" @click="$emit('cancel')">
        <span class="glicon-close-large"></span>
      </div>

      <template v-if="fieldToEdit === 'password'">
        <div class="form__group">
          <gl-input
            id="profile.currentPassword"
            v-model.trim="$v.form.currentPassword.$model"
            v-skeletor:onChange="setValue"
            :type="'password'"
            :label="$t('profile.edit.currentPassword')"
            :placeholder="$t('profile.edit.currentPassword')"
            :value="$v.form.currentPassword.$model"
            :errormessage="passwordError ? $t(`errors.${passwordError}`) : null"
          >
          </gl-input>
        </div>

        <div class="form__group">
          <gl-input
            id="profile.newPassword"
            v-model.trim="$v.form.newPassword.$model"
            v-skeletor:onChange="setValue"
            :type="'password'"
            :label="$t('profile.edit.newPassword')"
            :placeholder="$t('profile.edit.newPassword')"
            :value="$v.form.newPassword.$model"
            :errormessage="
              $v.form.newPassword.$model && $v.form.newPassword.$error
                ? $t('errors.passwordTooShort')
                : null
            "
          >
          </gl-input>
        </div>
        <password-strength-bar :password="$v.form.newPassword.$model"></password-strength-bar>

        <div class="form__group">
          <gl-input
            id="profile.confirmPassword"
            v-model.trim="$v.form.confirmPassword.$model"
            v-skeletor:onChange="setValue"
            :type="'password'"
            :label="$t('profile.edit.confirmPassword')"
            :placeholder="$t('profile.edit.confirmPassword')"
            :value="$v.form.confirmPassword.$model"
            :errormessage="
              $v.form.confirmPassword.$model && !$v.form.confirmPassword.isSamePassword
                ? $t('errors.passwordsDoNotMatch')
                : null
            "
          >
          </gl-input>
          <div style="display:none">{{ $v.form.confirmPassword }}</div>
        </div>
      </template>

      <div class="popup__buttons">
        <gl-button
          id="profile.btn-cancel"
          color-secondary
          :type="'button'"
          :text="$t('actions.cancel')"
          @onClick.prevent="$emit('cancel')"
        ></gl-button>
        <gl-button
          id="profile.btn-update"
          color-primary
          :type="'button'"
          :text="$t('actions.update')"
          :disabled="errors || !dirtyFields"
          @onClick.prevent="updateData"
        ></gl-button>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import PasswordStrengthBar from './PasswordStrengthBar.vue';
import { mapState } from 'vuex';
import { formatIds } from '../../utils/functions.js';

export default {
  name: 'EditPopup',
  components: {
    PasswordStrengthBar
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus();
      }
    }
  },
  props: {
    fieldToEdit: { type: String, required: true },
    passwordError: { type: String, default: '' }
  },
  data() {
    return {
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      isWrong: false,
      dirtyFields: false
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.profile.profileData
    }),
    errors() {
      switch (this.fieldToEdit) {
        case 'password':
          return (
            !this.$v.form.currentPassword.required ||
            !this.$v.form.newPassword.required ||
            !this.$v.form.confirmPassword.required ||
            this.$v.form.newPassword.$error ||
            !this.$v.form.confirmPassword.isSamePassword
          );
      }
      return false;
    }
  },
  watch: {
    passwordError() {
      this.form.currentPassword = '';
      this.form.newPassword = '';
      this.form.confirmPassword = '';
    }
  },
  methods: {
    setValue(field, value, dirty) {
      this.setForm(formatIds(field), value, dirty);
      this.setDirtyField(dirty);
    },
    setForm(attr, value) {
      this.$set(this.form, attr, value);
    },
    setDirtyField(dirty) {
      this.dirtyFields = dirty;
    },
    updateData() {
      if (this.fieldToEdit === 'password') {
        this.$emit('done', {
          currentPassword: this.form.currentPassword,
          newPassword: this.form.newPassword
        });
      } else {
        this.$emit('done', eval(`this.${this.fieldToEdit}`));
      }
    }
  },
  validations: {
    form: {
      currentPassword: { required },
      newPassword: { required, minLength: minLength(4) },
      confirmPassword: {
        required,
        isSamePassword(value) {
          return value === this.form.newPassword;
        }
      }
    }
  }
};
</script>
